<template>
  <div class="Resource-application">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        :data="tableFilterList(queryFields)"
        @search="dataTableSearch"
      >
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :showNumber="true"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        :toolBar="{hidden: true}"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";

export default {
  name: "ReleaseResource",
  mixins: [DataTableMixin],
  components: {
    DynamicSearch
  },
  data() {
    return {
      // total: 1,
      delLoading: false,
      queryFields: [
        {
          label: "人员",
          prop: "name",
          query: {
            type: "input"
          },
        }
      ],
      tableHead: [
        {
          label: "人员",
          prop: "bsPerson.name",
          align: "center"
        },
        {
          label: "释放项目",
          prop: "bsProject.name",
          align: "center"
        },
        {
          label: "结算单价",
          prop: "settlementPrice",
          align: "center"
        },
        {
          label: "原资源占用开始日",
          prop: "startDateOld"
        },
        {
          label: "原资源占用结束日",
          prop: "endDateOld"
        },
        {
          label: "现资源占用结束日",
          prop: "endDateNew",
          align: "center"
        },
        {
          label: "剩余申请人天",
          prop: "personDayLeft",
          align: "center"
        },
      ]
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
    dataTableBeforeInit() {
      this._url = "/resourceRelease/findListResourceRelease";
      const params = { page: this.page, size: this.offset };
      this._params = Object.assign(params, this._query);
      return true;
    },
    handleDeletes(rows) {
      rows.forEach(element => {
        this.subDelete(element.id);
      });
    },
    edit(row) {
      console.log(row);
      this.$router.push("ReleaseResource/form?id=" + row.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  height: 100%;
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width: 1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
